export const getPagination = ({ pagination }) => pagination;
export const getMappedTypesMeasure = () => ({
  goal: "Meta",
  indicator: "Indicador",
})
